/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import {
    object, func, string, shape,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
    tabsWrapper: {
        maxHeight: 60,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 10,
        fontSize: 25,
        [theme.breakpoints.down('sm')]: {
            fontSize: 0,
            paddingTop: 0,
            height: 30,
            justifyContent: 'space-around',
        },
    },
    tabsWrapperReview: {
        maxHeight: 60,
        display: 'flex',
        alignItems: 'center',
        marginTop: 10,
        [theme.breakpoints.down('sm')]: {
            paddingTop: 0,
            height: 30,
            justifyContent: 'space-around',
        },
    },
    selectTemplate: {
        [theme.breakpoints.down('xs')]: {
            fontSize: 0,
            '&::after': {
                content: '"Select"',
                fontSize: 25,

            },
        },
    },
    selectTab: {
        fontWeight: 'bold',
        lineHeight: '21px',
        textTransform: 'capitalize',
        padding: '10px 15px',
    },
    tab: {
        color: theme.palette.cgc?.bgTextOverlay1 || 'rgba(0,0,0,0.6)',
        textTransform: 'capitalize',
        padding: '0px 15px',
        [theme.breakpoints.down('xs')]: {
            padding: 0,
        },
    },
    personalizeCard: {
        [theme.breakpoints.down('xs')]: {
            fontSize: 0,
            '&::after': {
                content: '"Personalize"',
                fontSize: 25,
            },
        },
    },
    reviewCard: {
        [theme.breakpoints.down('xs')]: {
            fontSize: 0,
            '&::after': {
                content: '"Review"',
                fontSize: 25,

            },
        },
    },
});

const ModalViewNav = ({
    classes, setModalView, modalViews, selectedView, selectedCard, messageData,
}) => {
    const personalizeDisabled = !(selectedCard?.title?.length > 0);
    const reviewDisabled = !(messageData?.text?.length > 0);
    return (
        <Grid className={selectedView === modalViews.REVIEW ? classes.tabsWrapperReview : classes.tabsWrapper}>
            <Grid>
                <Button
                    className={`${classes.selectTemplate} ${selectedView === modalViews.SELECT_TEMPLATE ? classes.selectTab : classes.tab}`}
                    onClick={() => setModalView(modalViews.SELECT_TEMPLATE)}
                >
                    Select Greeting Card
                </Button>
            </Grid>
            <Grid className={selectedView === modalViews.PERSONALIZE ? classes.selectTab : classes.tab}>
                <Button
                    className={`${classes.personalizeCard} ${selectedView === modalViews.PERSONALIZE ? classes.selectTab : classes.tab}`}
                    onClick={() => setModalView(modalViews.PERSONALIZE)}
                    disabled={personalizeDisabled}
                >Personalize Card
                </Button>
            </Grid>
            <Grid className={selectedView === modalViews.REVIEW ? classes.selectTab : classes.tab}>
                <Button
                    className={`${classes.reviewCard} ${selectedView === modalViews.REVIEW ? classes.selectTab : classes.tab}`}
                    onClick={() => setModalView(modalViews.REVIEW)}
                    disabled={reviewDisabled}
                >
                    Review Card
                </Button>
            </Grid>
        </Grid>
    );
};

ModalViewNav.propTypes = {
    classes: object.isRequired,
    setModalView: func.isRequired,
    modalViews: shape({
        PERSONALIZE: string,
        REVIEW: string,
    }).isRequired,
    selectedView: string.isRequired,
    selectedCard: shape({
        title: string,
    }).isRequired,
    messageData: shape({
        text: string,
    }).isRequired,
};

export default withStyles(styles)(ModalViewNav);
